import { Box, Typography } from '@mui/material';
import ColorwayCard from './ColorwayCard';
import { objectToArray } from '../utils';

export default function ColorwaySelector({ item, onSelect }) {
  const selectColorway = (id) => {
    if (item.colorways && item.colorways[id]) {
      const colorway = { id, ...item.colorways[id] };
      onSelect(colorway);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Colorways
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, mt: 2, flexWrap: 'wrap' }}>
        {item.colorways &&
          objectToArray(item.colorways).map((colorway) => (
            <ColorwayCard key={colorway.id} colorway={colorway} onClick={() => selectColorway(colorway.id)} />
          ))}
      </Box>
    </Box>
  );
}
